import { ReportService, type ReportDO } from "./report.service"

export class ReportEmbed extends HTMLElement {
    private readonly slug: string = document.body.getAttribute("slug") ?? ""
    private readonly language: string | null = this.getAttribute("language")

    constructor(private reportService: ReportService = window.tbwServices.reportService) {
        super()
    }

    async connectedCallback() {
        if (!this.language || !this.verifyInput()) { return }
        if (window.tbwServices.authService.isAuthenticated) {
            await this.render()
        }
    }

    verifyInput() {
        return this.language === "fr" || this.language === "en" || this.language === "de"
    }

    async render() {
        this.innerHTML = '<p class="report-embed-loading">Loading...</p>'
        try {
            const content = await this.getReportUrl()
            const url = this.language === 'en' ? content.englishURL
                      : this.language === 'de' ? content.germanURL
                      : content.frenchURL
            // iOS Safari can't display PDFs inline in an <iframe> (shows blank).
            // Offer an explicit "Open the PDF" button that opens the native viewer.
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
                || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
            const viewer = isIOS
                ? `<div class="report-embed-ios" style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;height:100%;min-height:320px;padding:32px;text-align:center;">
                       <p style="margin:0;font-size:14px;color:#6b6880;max-width:32ch;">Open the report to read it full-screen.</p>
                       <a href="${url}" target="_blank" rel="noopener noreferrer" style="display:inline-flex;align-items:center;gap:8px;padding:13px 26px;background:#3442EB;color:#fff;text-decoration:none;border-radius:10px;font-size:15px;font-weight:600;">Open the PDF ↗</a>
                   </div>`
                : `<iframe src="${url}" style="width: 100%; height: 100%; border: none; flex: 1;"></iframe>`
            this.innerHTML = `
        <tbw-auth-state>
            <div slot="premium" style="width: 100%; height: 100%; display: flex; flex-direction: column;">
                <div class="report-embed" style="width: 100%; height: 100%; display: flex; flex-direction: column;">
                    ${viewer}
                </div>
            </div>
        </tbw-auth-state>
        `
        } catch {
            this.innerHTML = '<p class="report-embed-error">Unable to load report</p>'
        }
    }

    async getReportUrl(): Promise<ReportDO> {
        const content = await this.reportService.get(this.slug)
        return content
    }

}